export default __webpack_public_path__ + "img/app-page/screen2.6cd01f9cf709fde9e8f377bf9a60ad49.png";